import { AppSettings } from "../Constants/AppSettings"



export const photosource = (identy: string) => {
    return `${AppSettings.loadendpoint}/photo/${identy}`
}